const faqItems = [
  {
    question: 'Hoelang duurt een badkamerrenovatie?',
    answer: 'Een gemiddelde badkamerrenovatie duurt 1 tot 2 weken, afhankelijk van de omvang van het werk. Wij plannen alles zorgvuldig in zodat u zo min mogelijk overlast heeft.',
  },
  {
    question: 'Wat kost een keukenrenovatie in Antwerpen?',
    answer: 'De prijs van een keukenrenovatie hangt af van de grootte, materialen en het gewenste afwerkingsniveau. Wij bieden altijd een gratis en vrijblijvende offerte op maat aan.',
  },
  {
    question: 'Werkt NGP Renovatieproject ook buiten Antwerpen?',
    answer: 'Ja, wij werken in de volledige regio Antwerpen, inclusief Merksem, Deurne, Borgerhout, Berchem en omliggende gemeenten.',
  },
  {
    question: 'Kan ik één aannemer inschakelen voor de volledige renovatie?',
    answer: 'Absoluut. NGP Renovatieproject verzorgt de volledige renovatie van A tot Z: van sloop en ruwbouw tot afwerking en schilderwerk. U heeft één aanspreekpunt voor het hele project.',
  },
  {
    question: 'Hoe vraag ik een offerte aan?',
    answer: 'U kunt eenvoudig een offerte aanvragen via ons offerteformulier, per telefoon (0460 94 02 22) of per e-mail. Wij nemen binnen 24 uur contact met u op.',
  },
];

import { useState } from 'react';

const ServiziFAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-24 bg-white">
      <div className="max-w-3xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-2 bg-amber-50 rounded-full text-xs font-medium text-amber-700 uppercase tracking-wider mb-4">
            Veelgestelde Vragen
          </span>
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900" style={{ fontFamily: 'Playfair Display, serif' }}>
            Alles wat u wilt weten
          </h2>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, index) => (
            <div
              key={index}
              className="border border-gray-100 rounded-xl overflow-hidden shadow-sm"
            >
              <button
                className="w-full flex items-center justify-between px-6 py-5 text-left bg-white hover:bg-gray-50 transition-colors cursor-pointer"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                aria-expanded={openIndex === index}
              >
                <span className="text-sm font-semibold text-gray-900 pr-4">{item.question}</span>
                <span className="w-6 h-6 flex items-center justify-center flex-shrink-0 text-gray-500">
                  <i className={`transition-transform duration-300 ${openIndex === index ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
                </span>
              </button>
              {openIndex === index && (
                <div className="px-6 pb-5 bg-white">
                  <p className="text-sm text-gray-600 leading-relaxed">{item.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export { faqItems };
export default ServiziFAQ;
